import { CaseListingNoResultsFound } from 'app/area/case-report/components/case-listing-no-results-found';
import { CaseReportFailedExecute } from 'app/area/case-report/components/case-report-failed-execute';
import { CaseReportListingInformation } from 'app/area/case-report/components/case-report-listing-information';
import React from 'react';

interface CaseListingExceptionProps {
  autoExecute: boolean;
  errorsExecuteFailed?: string[];
  fetching: boolean;
  totalNumberOfResults: number;
  translation: Record<string, string>;
}
export function useCaseListingException({ autoExecute, errorsExecuteFailed, fetching, totalNumberOfResults, translation }: 
  CaseListingExceptionProps) {
  const hasExecuteFailedErrors = autoExecute && !!errorsExecuteFailed && !!errorsExecuteFailed.length;
  const noResultsFound = autoExecute && !fetching && totalNumberOfResults === 0;

  let Component = null;
  if (hasExecuteFailedErrors) {
    Component = <CaseReportFailedExecute translation={translation} errorsExecuteFailed={errorsExecuteFailed} />;
  } else if (noResultsFound) {
    Component = <CaseListingNoResultsFound translation={translation} />;
  } else if (!autoExecute) {
    Component = <CaseReportListingInformation translation={translation} />;
  }
  return Component;
}
